<ng-container *ngIf="isReadonly; then readonlyContent; else editableContent"></ng-container>

<ng-template #readonlyContent>
  <div [class]="cssClass">
    <div class="row m-0 align-items-center">
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">
          {{ 'Conversation::' + text | abpLocalization }}
          {{ { key: 'Conversation::' + text + ':Unit', defaultValue: ' ' } | abpLocalization }}
        </label>
      </div>
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">{{ payload.operator | operator }}</label>
      </div>
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">{{ payload.value }}</label>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #editableContent>
  <div [class]="cssClass">
    <div showButtonsOnHover class="row m-0 align-items-center full-height">
      <div class="col-auto">
        <label style="margin-bottom: 0px !important">
          {{ 'Conversation::' + text | abpLocalization }}
          {{ { key: 'Conversation::' + text + ':Unit', defaultValue: ' ' } | abpLocalization }}
        </label>
      </div>
      <div class="col-auto">
        <select
          class="form-select form-select-sm"
          [(ngModel)]="payload.operator"
          (ngModelChange)="operatorChanged()">
          <option *ngFor="let operator of node.categoryItem.operators" [value]="operator">
            {{ operator | operator }}
          </option>
        </select>
      </div>
      <div class="col-auto">
        @if (isDecimalField) {
          <input
            (change)="validateInput($event.target.value)"
            [(ngModel)]="payload.value"
            autoSelectOnFocus
            [max]="max"
            [min]="min"
            class="form-control form-control-sm"
            type="number"
            step="0.01"
            (ngModelChange)="valueChanged()" />
        } @else {
          <input
            (change)="validateInput($event.target.value)"
            [(ngModel)]="payload.value"
            autoSelectOnFocus
            [max]="max"
            [min]="min"
            class="form-control form-control-sm"
            type="number"
            (ngModelChange)="valueChanged()" />
        }
      </div>
      <div style="gap: 8px" class="col-auto d-flex flex-row justify-content-center">
        <ca-query-builder-node-duplicate-button
          (buttonClick)="onClickDuplicate($event)"></ca-query-builder-node-duplicate-button>
        <ca-query-builder-node-remove-button
          (buttonClick)="removeNode($event)"></ca-query-builder-node-remove-button>
      </div>
    </div>
  </div>
</ng-template>
